import {Component, HostListener, inject, NgZone} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {UiService} from '../shared/services/ui.service';
import {Title} from "@angular/platform-browser";
import {takeWhile} from "rxjs";
import {Utils} from "../shared/utils/generics.utils";
import {EventTrackerService} from "../shared/services/event-tracker.service";
import {CookiesConsentService} from "../shared/components/cookies-consent/services/cookies-consent.service";
import * as Sentry from "@sentry/angular";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {MatomoTracker} from "ngx-matomo-client";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {

  public translate = inject(TranslateService);
  private titleService = inject(Title);
  public ui = inject(UiService);
  private tracker = inject(EventTrackerService);
  private matomoTracker = inject(MatomoTracker);
  private cookies = inject(CookiesConsentService);
  private ngZone = inject(NgZone);

  constructor() {
    // Set title
    const subDomain = Utils.getCompanyFromDomain();
    this.titleService.setTitle(Utils.capitalizeFirstLetter(subDomain));

    this.cookies.cookieChanges$.pipe(
      takeUntilDestroyed(),
      // stop if user accepts, because we cannot remove it anyway
      takeWhile((preferences) => !preferences.functionality.value, true)
    ).subscribe((preferences) => {
      // else freezes on landing button click
      this.ngZone.runOutsideAngular(() => {
        if (!preferences.performance.value) {
          this.matomoTracker.deleteCustomVariable(1, "visit");
          Sentry.setUser(null);
          Sentry.setTag("vehicle_id", undefined);
        }
      })
    });
  }

  @HostListener('window:beforeunload')
  onBeforeunload() {
    this.tracker.trackEvent('Navigation', 'Window close', undefined);
  }

  @HostListener('window:focus', ['$event'])
  onFocus() {
    this.tracker.trackEvent('Navigation', 'Window focus', undefined);
  }

  @HostListener('window:blur', ['$event'])
  onBlur() {
    this.tracker.trackEvent('Navigation', 'Window blur', undefined);
  }
}
